import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SubscriptionCard from './SubscriptionCard/SubscriptionCard';
import classNames from 'classnames';
import classes from './Partners.module.scss';
import ListItem from '@shared/ListItem/ListItem';
import { useSelector } from 'react-redux';
import { versionSelector } from '@store/models/user/selectors';
import { partnersBlockConfig, partnersChildVersion, partnersChildVersionSubscription, partnersForChild, partnersForParent, } from '@configs/partners';
import { availablePlanSelector, isSubscriptionActiveSelector, showLeoniSelector } from '@store/models/subscription/selectors';
const Partners = () => {
    const version = useSelector(versionSelector);
    const isParent = version === 'parent';
    const showLeoni = useSelector(showLeoniSelector);
    const { plan } = useSelector(availablePlanSelector);
    const isSubscriptionActive = useSelector(isSubscriptionActiveSelector);
    const data = partnersBlockConfig[version](plan);
    const blockClasses = classNames(classes.subscription, classes[version]);
    const getCards = ({ cards, className }) => {
        return (_jsx("ul", { className: classNames(classes.list, classes[version], className), children: cards.map(el => {
                const isLeoni = el.name === 'leoni';
                if (!showLeoni && isLeoni) {
                    return _jsx(_Fragment, {});
                }
                return (_jsx(ListItem, { type: "li", className: classNames(classes.item, classes[el.name]), children: _jsx(SubscriptionCard, { element: el }) }, el.name));
            }) }));
    };
    const cardsForChildVersion = isSubscriptionActive ? partnersChildVersionSubscription : partnersChildVersion;
    return (_jsxs("section", { className: blockClasses, "data-testid": "partners", children: [_jsx("h2", { className: classes.title, children: data.title }), _jsx("p", { className: classes.promo, children: data.promoText }), _jsx("div", { className: classes.content, children: isParent ? (_jsxs(_Fragment, { children: [_jsx("h3", { children: "\u0420\u043E\u0434\u0438\u0442\u0435\u043B\u044E" }), getCards({ cards: partnersForParent, className: classes.forParent }), _jsx("h3", { children: "\u0420\u0435\u0431\u0451\u043D\u043A\u0443" }), getCards({ cards: partnersForChild })] })) : (getCards({ cards: cardsForChildVersion })) })] }));
};
export default Partners;
